import Main from '@/views/Main'

// 菜单中未使用的其他页面路由
export const h5Router = {
	path: '/',
	name: 'ford',
	component: Main,
	children: [
		
		// 绑定充电桩 图1.0.0
		{
			path: '/pileAddWelcome',
			name: 'pileAddWelcome',
			component: resolve => {
				require(['../views/pile-add-welcome/pile-add-welcome.vue'], resolve);
			}
		},
		// 绑定充电桩 图1.1.0
		{
			path: '/pileAdd',
			name: 'pileAdd',
			component: resolve => {
				require(['../views/pile-add/pile-add.vue'], resolve);
			}
		},
		// 敬请期待 Coming Soon
		// {
		// 	path: '/comingSoon',
		// 	name: 'comingSoon',
		// 	component: resolve => {
		// 		require(['../views/coming-soon/index.vue'], resolve);
		// 	}
		// },
		// 绑定充电桩成功 图1.2.0
		{
			path: '/pileAddSuccess',
			name: 'pileAddSuccess',
			component: resolve => {
				require(['../views/pile-add-success/pile-add-success.vue'], resolve);
			}
		},

		//编辑充电桩 图1.1.1
		{
			path: '/pileEdit',
			name: 'pileEdit',
			component: resolve => {
				require(['../views/pile-edit/pile-edit.vue'], resolve);
			}
		},

		//我的充电桩(开始充电/结束充电) 图1.3.0
		{
			path: '/',
			name: 'pileList',
			component: resolve => {
				require(['../views/pile-list/pile-list.vue'], resolve);
			},
		},

		//电桩详情(开始充电/结束充电) 图2.2.0
		{
			path: '/pileDetail',
			name: 'pileDetail',
			component: resolve => {
				require(['../views/pile-detail/pile-detail.vue'], resolve);
			}
		},
		{
			path: '/pilePlan',
			name: 'pilePlan',
			component: resolve => {
				require(['../views/pile-plan/pile-plan.vue'], resolve);
			}
		},
		{
			path: '/pilePlanDetail',
			name: 'pilePlanDetail',
			component: resolve => {
				require(['../views/pile-plan-detail/pile-plan-detail.vue'], resolve);
			}
		},
		{
			path: '/msgList',
			name: 'msgList',
			component: resolve => {
				require(['../views/msg-list/msg-list.vue'], resolve);
			},
		},
		
		{
			path: '/pileChargeHistory',
			name: 'pileChargeHistory',
			component: resolve => {
				require(['../views/pile-charge-history/pile-charge-history.vue'], resolve);
			}
		},
		{
			path: '/pileChargeHistoryDetail',
			name: 'pileChargeHistoryDetail',
			component: resolve => {
				require(['../views/pile-charge-history/pile-charge-history-detail.vue'], resolve);
			}
		},
		{
			path: '/pileChargeHistoryCharts',
			name: 'pileChargeHistoryCharts',
			component: resolve => {
				require(['../views/pile-charge-history-charts/pile-charge-history-charts.vue'], resolve);
			}
		},
		{
			path: '/test',
			name: 'test',
			component: resolve => {
				require(['../views/test/test.vue'], resolve);
			}
		},


		//充电历史详情 图5.2.0
		// {
		// 	path: 'historyMore',
		// 	name: 'historyMore',
		// 	component: resolve => {
		// 		require(['../views/charge-history/historymore.vue'], resolve);
		// 	}
		// },

	]
};

// 所有上面定义的路由都要写在下面的routers里
export const routers = [
	h5Router
];



// WEBPACK FOOTER //
// ./src/router/index.js